import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Header from "../components/Header.js"

import { Box, AppBar, Container, Paper, Typography, Link } from '@material-ui/core'

import Spinner from './Spinner'
import Datepicker from './Datepicker'
import DRSTable from './DRSTable'

const useStyles = makeStyles((theme) => ({
  disclaimerContainer: {
      padding: 10,
      maxWidth: "90%",
      margin: 'auto',      
  }
}));

const Dashboard = () => {

    const [info, setInfo] = useState([])
    const [date, setDate] = useState('')
    const [isLoading, setIsLoading] = useState(true)

    const handleClickLeft = () => {
        const dateIndex = datasDisponiveis.indexOf(date)
        if (dateIndex !== 0) {
            setDate(datasDisponiveis[dateIndex-1])
        }
    }
    const handleClickRight = () => {
        const dateIndex = datasDisponiveis.indexOf(date)
        if (dateIndex !== datasDisponiveis.length-1) {
            setDate(datasDisponiveis[dateIndex+1])
        }
    }

    useEffect(() => {
        const fetchItems = async () => {
            const result =  await axios.get(`https://raw.githubusercontent.com/Dereooo/planosp/master/KPI/data/kpi.json`)

            setInfo(result.data)
            setDate(Object.keys(result.data[result.data.length - 1])[0])
            setIsLoading(false)

        }

        fetchItems()

    }, [])

    const datasDisponiveis = info.map(x => Object.keys(x)[0])
    const infoData = info.filter(x => date in x)["0"]

    const classes = useStyles();

    const dateUnparse = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    const dateParse = (date) => {
        const year = date.slice(0,4);
        const month = date.slice(5,7);
        const day = date.slice(8,10);
        var d = new Date(year,month-1, day); 
        return d;
    }

    const Disclaimer = () => (
        <div className='center'>
            <Paper className={classes.disclaimerContainer}>

          <Typography align="justify" variant="caption">(*) Obs.: Até o momento, o Governo de São Paulo não tornou públicas as informações diárias sobre ocupação de leitos de UTI. Portanto, o número apresentado é uma estimativa feita usando a média dos dias que foram divulgados.</Typography>
            <Box my={2}/>
            <Typography align="justify" variant="caption">
                Disclaimer: Este site não possui vínculo com nenhum órgão governamental e as informações aqui contidas não têm caráter oficial. Para informações oficiais sobre o Plano SP, acesse o <Link href="https://www.saopaulo.sp.gov.br/planosp/" target="_blank">site do Governo de São Paulo</Link>.
            </Typography>
            </Paper>
        </div>
    );

    return isLoading ? (<Spinner />) : (
        <div>
        <Header />
            
        <DRSTable
        infoData={infoData}
        date={date}
        />
        <Disclaimer />
        <Datepicker
        dateUnparse={dateUnparse}
        dateParse={dateParse}
        datasDisponiveis={datasDisponiveis}
        date={date}
        onDateChange = {(e) => {
            setDate(dateUnparse(e))
        }}
        onClickLeft = {handleClickLeft}
        onClickRight = {handleClickRight}
        />
        <div style={{marginBottom: '100px'}}/>
        </div>
    )
}

export default Dashboard;
